import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueGtm from 'vue-gtm';
import { cloneDeep } from 'lodash';
import registerVueGlobals from '@/registerVueGlobals';
import store from './store';
import App from './App.vue';
import router from './router';
import api from './services/api';
import initVuetify from './plugins/vuetify';
import * as constants from './helpers/constants';
import * as helpers from './helpers/helpers';

import '@/assets/scss/general.scss';

const getConfig = async () => {
  const partnerConfigResponse = await Vue.prototype.$api.initForm();

  if (partnerConfigResponse.status !== 'success') throw new Error('Config is not available.');
  return helpers.processConfig(
    Object.assign(
      {},
      cloneDeep(constants.DEFAULT_WL_CONFIG),
      partnerConfigResponse.data,
    ),
  );
};

const initGTM = gtmCode => {
  if (process.env.NODE_ENV !== 'production') return;

  Vue.use(VueGtm, {
    id: gtmCode,
    enabled: false,
  });
};

(async () => {
  Vue.use(VueMeta);
  Vue.config.productionTip = false;
  Vue.prototype.$api = api;
  Vue.config.devtools = process.env.NODE_ENV !== 'production';

  try {
    const config = await getConfig();

    registerVueGlobals(config);
    helpers.initPartnerFonts(config);

    initGTM(config.gtmCode);

    router.beforeEach((to, from, next) => {
      const userIds = config.userIdForRetrieveLogin || store.getters.userIds;
      const userEmail = config.emailForRetrieveLogin || store.getters.userEmail;
      const memberId = config.memberIdForRetrieveLogin || store.getters.memberId;
      const isAuthenticated = (userIds && userEmail) || memberId;

      const ROUTES_AVAILABLE_WITHOUT_AUTH = ['Login', 'ForgotPassword', 'ResetPassword'];

      if (!ROUTES_AVAILABLE_WITHOUT_AUTH.includes(to.name) && !isAuthenticated) {
        next({ name: 'Login' });
        return;
      }

      if (ROUTES_AVAILABLE_WITHOUT_AUTH.includes(to.name) && isAuthenticated) {
        next({ name: 'Quotes' });
        return;
      }

      next();
    });

    new Vue({
      store,
      router,
      vuetify: initVuetify(config),
      provide: {
        constants,
        helpers,
        config,
      },
      render: (h) => h(App),
    }).$mount('#app');
  } catch (error) {
    console.warn(error);
  }
})();
